import axiosInstance from "../Axios-Config/Axios-Config";
import { ErrorToast } from "../components/ToastComponent/ErrorToast";
import { circulatRefrenceRemoveWithKey } from "../utils/helper";
const orderApi = async (state: any) => {
let payload=circulatRefrenceRemoveWithKey(state)
  try {
    const { data }: any = await axiosInstance.post("save/order", payload);

    if (data?.success && data?.order_id) {
      // SuccessToast(data.message);
      return data;
    } else {
      ErrorToast(data?.message);
      return false;
    }
  } catch (error: any) {
    console.log("_error.message",state,error)
    ErrorToast(error.message);
    return false;
  }
};
export default orderApi;
